import api from "../api/axios";

const productService = {
  // Ürün listesi
  getAll: () => api.get("product/get-all-products"),

  // Id'ye göre ürün
  getById: (id) => api.get(`product/get-product/${id}`),

  // Ürün ekle
  create: (data) => api.post("product/create", data),

  // Ürün güncelle
  update: (data) => api.post("product/update", data),

  // Soft delete
  delete: (id) => api.delete(`product/delete/${id}`),

  // Excel import
  importExcel: (formData) => api.post("product/import-excel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }),

  // Örnek Excel indir
  downloadSample: () => api.get("product/download-sample", {
    responseType: "blob",
  }),

  // Ürün arama (AutoComplete)
  getAutoComplete: (query, take = 20) => api.get("product/autocomplete", { params: { query, take } }),

  // Satış için ürün arama
  saleSearch: (query, take = 20) => api.get("product/sale-product-search", { params: { query, take } }),
};

export default productService;